import { render, staticRenderFns } from "./PodcastsSlider.vue?vue&type=template&id=1c80ea8a&"
import script from "./PodcastsSlider.vue?vue&type=script&lang=js&"
export * from "./PodcastsSlider.vue?vue&type=script&lang=js&"
import style0 from "./PodcastsSlider.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PodcastsSlider.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./PodcastsSlider.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports